export default {"src":"/_next/static/media/KCS.c992f28b.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};